import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment, useCallback, useEffect } from 'react';
import { post } from '../Services/http';
function LiveEditing() {
    const handleBlockUpdatedEvent = useCallback(async ({ systemId }) => {
        const blockElements = document.querySelectorAll(`[data-litium-block-id="${systemId}"]`);
        if (!blockElements || blockElements.length === 0) {
            console.warn('Block not found:', systemId);
            return;
        }
        const content = await post(`/api/blockpreview`, systemId);
        const html = await content.text();
        blockElements.forEach((element) => {
            element.innerHTML = html;
        });
        // bootstrap react components if any updated
        window.__litium.bootstrapComponents();
    }, []);
    const handleBlockAddedEvent = useCallback(async ({ systemId, referenceBlockSystemId, addBefore, emptyContainer, }) => {
        if (emptyContainer) {
            // adding a block to an empty container, we should reload the page as there is no container information
            // so we can't locate the position of the new block.
            window.location.reload();
            return;
        }
        const referenceBlockElement = document.querySelector(`[data-litium-block-id="${referenceBlockSystemId}"]`);
        if (!referenceBlockElement) {
            console.warn('Block not found:', referenceBlockSystemId);
            return;
        }
        const content = await post(`/api/blockpreview`, systemId);
        const html = await content.text();
        const section = document.createElement('section');
        section.setAttribute('data-litium-block-id', systemId);
        section.innerHTML = html;
        if (addBefore) {
            referenceBlockElement.insertAdjacentElement('beforebegin', section);
        }
        else {
            referenceBlockElement.insertAdjacentElement('afterend', section);
        }
        // bootstrap react components if any added
        window.__litium.bootstrapComponents();
    }, []);
    const handleBlockDeletedEvent = useCallback(({ systemId }) => {
        const blockElement = document.querySelector(`[data-litium-block-id="${systemId}"]`);
        if (!blockElement) {
            console.warn('Block not found:', systemId);
            return;
        }
        blockElement.remove();
    }, []);
    useEffect(() => {
        const handlers = [
            window.litiumBridge.on('blockUpdated', handleBlockUpdatedEvent),
            window.litiumBridge.on('blockAdded', handleBlockAddedEvent),
            window.litiumBridge.on('blockDeleted', handleBlockDeletedEvent),
        ];
        return () => {
            handlers.forEach((off) => off && off());
        };
    }, [
        handleBlockAddedEvent,
        handleBlockDeletedEvent,
        handleBlockUpdatedEvent,
    ]);
    return _jsx(Fragment, {});
}
export default LiveEditing;
